import { request } from '@/utils/request'
const API ={
    helpUpdate: '/sys/help-doc/edit', //编辑  
    helpFields: '/sys/help-doc/fields', //查询条件  
    helpInfo: '/sys/help-doc/info', //详情
    helpList: '/sys/help-doc/list', //列表
}
export const helpApi = {
  // 通用上传（供富文本使用）
  async uploadCommon(formData) {
    // formData: must include: billId, parentBillId, projectId, fileType(optional), isEditFlage(optional), file
    return request.post('/common/upload', formData).then(res => {
      return res
    })
  },
  // 获取帮助文档列表
  getHelpList(params = {}) {
    // 如果没有参数，直接获取所有数据
    if (Object.keys(params).length === 0) {
      return request.post(API.helpList).then(res => {
        if (res.code === 200) {
          return {
            code: 200,
            data: res.data || []
          }
        }
        return res
      })
    }

    // 如果有筛选条件，构建请求参数
    const formData = new URLSearchParams()
    Object.keys(params).forEach(key => {
      formData.append(key, params[key])
    })

    return request.post(API.helpList, formData).then(res => {
      if (res.code === 200) {
        return {
          code: 200,
          data: res.data || []
        }
      }
      return res
    })
  },
  
  // 获取筛选字段
  getHelpFields() {
    // 与通讯录保持一致，使用 GET 方式获取字段
    return request.get(API.helpFields).then(res => {
        if (res.code === 200) {
          return { code: 200, data: res.data || [] }
        }
        return res
    })
  },
  
  // 获取帮助文档详情
  getHelpInfo(menuId) {
    return request.post(API.helpInfo, { menuId: menuId }).then(res => {
      if (res.code === 200) {
        return { code: 200, data: res.data || {} }
      }
      return res
    })
  },
  
  // 更新帮助文档
  getHelpUpdate(params) {
    const formData = new URLSearchParams()
    Object.keys(params).forEach(key => {
      formData.append(key, params[key])
    })

    return request.post(API.helpUpdate, formData).then(res => {
      if (res.code === 200) {
        return { code: 200, data: res.data || {} }
      }
      return res
    })
  },
}